import { App, Button, Spin } from "antd";
import { useEffect, useRef, useState } from "react";

import { PrimaryText } from "@/shared/ui/Typography";

import { LoaderMask } from "./Styled";

type LazyFallbackLoaderProps = {
    timeoutMs?: number;
    notifyMessage?: string;
    notifyDescription?: string;
    onTimeout?: () => void;
};

export const LazyFallbackLoader = ({
    timeoutMs = 10_000,
    notifyMessage = "Не вдалося завантажити сторінку",
    notifyDescription = "Спробуйте оновити сторінку або перевірте підключення до мережі.",
    onTimeout,
}: LazyFallbackLoaderProps) => {
    const { notification } = App.useApp();

    const [visible, setVisible] = useState(true);
    const notifiedRef = useRef(false);
    const timerRef = useRef<NodeJS.Timeout | null>(null);

    useEffect(() => {
        timerRef.current = setTimeout(() => {
            setVisible(false);

            if (!notifiedRef.current) {
                notifiedRef.current = true;
                notification.error({
                    title: notifyMessage,
                    description: notifyDescription,
                    duration: 10,
                    btn: (
                        <Button
                            onClick={() => window.location.reload()}
                            type="primary"
                            size="small"
                        >
                            Оновити
                        </Button>
                    ),
                });
            }

            onTimeout?.();
        }, timeoutMs);

        return () => {
            if (timerRef.current) {
                clearTimeout(timerRef.current);
            }
        };
    }, [notification, timeoutMs, notifyMessage, notifyDescription, onTimeout]);

    if (!visible) {
        return null;
    }

    return (
        <LoaderMask>
            <PrimaryText>Завантаження</PrimaryText>
            <Spin size="large" />
        </LoaderMask>
    );
};
